
import React from "react";
export default function Companies() {
  return (
    <section className="max-w-7xl mx-auto px-4 py-12">
      <p className="text-center text-slate-600 dark:text-slate-300">
        750+ companies hire from us
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {['Cognizant','Capgemini','NTT Data','Bluebonder','AppEx'].map(c => (
          <span key={c} className="logo-pill">{c}</span>
        ))}
      </div>
    </section>
  );
}
